import React, { useState, useContext, useEffect, useReducer, useRef } from 'react';
import "../../site.css";
import { AuthContext } from "../../AuthContext";
import * as FaIcons from 'react-icons/fa';
import * as BsIcons from "react-icons/bs";
import * as RiIcons from "react-icons/ri";
import { Envelope, EnvelopeFill, Phone, Telephone } from 'react-bootstrap-icons';
import { getToken, saveToken } from '../Hooks/Token';
import moment from "moment";
import { getAPI } from '../GdacsAPI';
import { useViewPort } from '../Hooks/useViewPort';
import { SlidingPane } from '../SlidingPane';
import { Button, Card, Modal } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';
import { ValidateEditor } from './ValidateEditor';

const ValidateWidget = (props) => {
    const authContext = React.useContext(AuthContext);
    const [addresses, setAddresses] = React.useState(authContext.data?.addresses.map((a, i) => ({ ...a, id: i, messageText: "", disableButton: false })) ?? []);
    const [responseMessage, setResponseMessage] = React.useState("");
    const [userData, setUserData] = React.useState(authContext.data);
    const [address, setAddress] = React.useState(props.address);
    const [isEditorVisible, setIsEditorVisible] = useState();
    const [editingAddressId, setEditingAddressId] = React.useState();
    const [isVisible, setIsVisible] = React.useState();
    const [isValidated, setIsValidated] = React.useState(false);
    const [show, setShow] = React.useState(false);
    const [disabledButton, setDisabledButton] = React.useState(false);
    const captchaRef = useRef(null);

    React.useEffect(() => {

    }, [addresses]);


    const handleCaptcha = async (e, address) => {
        e.preventDefault();
        const token = e;
        captchaRef.current.reset();
        address.tokencaptcha = token;
    }

    const handleClose = () => {
        setShow(false);
        setIsValidated(undefined);
    }

        async function GetUserToken(values) {
        let json = {
            username: values
        }
        const settings = {
            method: 'POST',
            type: 'no-cors',
            body: JSON.stringify(json),
            headers: {
                'Authorization': 'Bearer ' + getToken(),
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        };

        const responseCredentials = await fetch(getAPI() + `api/register/Users/getuserbyusername/`, settings)
        if (!responseCredentials.ok) {
            const resp = await responseCredentials.json();
            setResponseMessage(resp.message);
            return;
        }
        else {
            const dataUser = await responseCredentials.json();
            authContext.update(dataUser);
        }
    }


    const handleTest = (address) => {
        SendTest(address);
    }

    async function SendTest(address) {
        let json = {
            username: authContext.data.username,
            idServiceType: address.idServiceType,
            addressValue: address.addressValue
        }

        const settings = {
            method: 'POST',
            /*            body: JSON.stringify(json),*/
            headers: {
                'Authorization': 'Bearer ' + authContext.token,
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'token-captcha': address.tokencaptcha
            }
        };

        const response = await fetch(getAPI() + `api/register/Users/RequireTestMessage?username=` + authContext.data.username + `&addressValue=` + (address.idServiceType === 3 ? address.addressValue.replace(/\+/g, '%2B') : address.addressValue) + `&idservicetype=` + address.idServiceType, settings);
        if (!response.ok) {
            const resp = await response.json();
            address.messageText = resp.message;
            //setResponseMessage(resp.message);
            return;
        }
        else {
            address.messageText = (address.idServiceType === 1
                ? "EMAIL Test message has been sent, you'll receive it by few minutes."
                : "SMS Test message has been sent, you'll receive it by few minutes.");
            //setResponseMessage(address.idServiceType === 1 ? "EMAIL Test message has been sent, you'll receive it by few minutes." : "SMS Test message has been sent, you'll receive it by few minutes.");
        }
    }

    const handleSMSCode = (address) => {
        SendSmsCode(address);
        GetUserToken(authContext.data.username);
        //setDisabledButton(true);
    }

    async function SendSmsCode(address) {
        if (responseMessage !== "")
            setResponseMessage("");

        let json = {
            username: authContext.data.username,
            addressValue: address.addressValue
        }

        const settings = {
            method: 'POST',
            body: JSON.stringify(json),
            headers: {
                'Authorization': 'Bearer ' + authContext.token,
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'token-captcha': address.tokencaptcha
            }
        };

        const response = await fetch(getAPI() + (address.idServiceType === 1 ? `api/register/Users/RequireEmailCode` : `api/register/Users/RequireSmsCode`), settings);
        if (!response.ok) {
            const resp = await response.json();
            address.messageText = resp.message;
            setDisabledButton(false);
/*            setResponseMessage(resp.message);*/
            return;
        }
        else {
            address.disableButton = true;
            address.messageText = (address.idServiceType === 1
                ? "EMAIL code has been sent, you'll receive it by few minutes."
                : "SMS code has been sent, you'll receive it by few minutes.");
/*                : <div className="p_summary">Our team will revise your number and will then send an SMS with the activation code that you need to include in your account to complete the registration process. If you do not receive any SMS message within 7 days, please contact <a href='https://www.gdacs.org/About/contactus.aspx' target='_blank'>us</a></div>);*/
            setDisabledButton(true);
            //setResponseMessage(address.idServiceType === 1
            //    ? <>EMAIL code has been sent, you'll receive it by few minutes.</>
            //    : <>Our team will revise your number and will then send an SMS with the activation code that you need to include in your account to complete the registration process. If you do not receive any SMS message within 7 days, please contact <a href="https://www.gdacs.org/About/contactus.aspx" target="_blank">us</a></>);
        }
    }

    async function GetUserCode() {
        let json = {
            username: authContext.username
        }
        const settings = {
            method: 'POST',
            body: JSON.stringify(json),
            headers: {
                'Authorization': 'Bearer ' + authContext.token,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        };


        const response = await fetch(getAPI() + `api/register/Users/getuserbyusername/`, settings);
        if (!response.ok) {
            const resp = await response.json();
            setResponseMessage(resp.message);
            return;
        }
        else {
            const dataUser = await response.json();
            return dataUser;
        }
    }

    const handleSaveCode = async (address) => {
        const err = checkCode(address);
        if (err === "") {
            let result = await GetUserCode();
            const addressCheck = result.addresses.filter(x => x.idUserAddress === address.idUserAddress);

            if (addressCheck[0].checkcode === address.checkcode) {

                setAddresses(aa => {
                    let newAddresses = [...aa];
                    const addressIndex = newAddresses.findIndex(a => a.id === address.id);
                    newAddresses[addressIndex] = address;
                    setEditingAddressId(undefined);
                    setIsValidated(true);
                    setIsEditorVisible(false);
                    address.messageText = "Code inserted OK. Please click Confirm button to validate number.";
                    //setResponseMessage("Code inserted OK. Please click Confirm button to validate number.");
                    return newAddresses

                });
            }
            else {
                setAddresses(aa => {
                    address.checkvalidate = false;
                    let newAddresses = [...aa];
                    const addressIndex = newAddresses.findIndex(a => a.id === address.id);
                    newAddresses[addressIndex] = address;
                    setEditingAddressId(undefined);
                    setIsValidated(false);
                    setIsEditorVisible(false);
                    address.messageText = "Code digited is not correct.";
                    //setResponseMessage("Code inserted OK. Please click Confirm button to validate number.");
                    return newAddresses

                });
            }
        }
        else {
            setIsEditorVisible(false);
        }
    }


    const checkCode = (address) => {
        let message = "";

        if (address.idServiceType === 3 && address.checkcode !== "undefined") {
            var pattern = new RegExp(/^[0-9]*$/);
            if (!pattern.test(address.checkcode)) {
                /*                isValid = false;*/
                /*                errors["phone"] = "Please enter only number.";*/
                message = "Please enter only number.";
            } else if (address.checkcode.length !== 4) {
                /*                isValid = false;*/
                message = "The number inserted contains too many numbers. Please enter valid phone number.";
            }
        }
        return message;
    }

    const handleSubmit = (e) => {
        if (responseMessage !== "")
            setResponseMessage("");

        SaveRecord(addresses);
    }

    async function SaveRecord(addresses) {

        let addressesValidate = [];
        for (let i = 0; i < addresses.length; i++) {
            addressesValidate.push({
                idUserAddress: addresses[i].idUserAddress, idServiceType: addresses[i].idServiceType, addressOption: addresses[i].addressOption,
                deviceKey: addresses[i].deviceKey === "", addressValue: addresses[i].addressValue, checkcode: addresses[i].checkcode,
                checkvalidate: addresses[i].checkvalidate, checkdate: addresses[i].checkdate, requiretest: addresses[i].requiretest
            });
        }

        let json = {
            idUser: userData?.idUser,
            lastName: userData?.lastName,
            firstName: userData?.firstName,
            country: userData?.country,
            email: userData?.email,
            enabled: userData?.enabled,
            emailOption: userData?.emailOption,
            username: userData?.username,
            password: userData?.password,
            notes: userData?.notes,
            organisation: userData?.organisation,
            orgtype: userData?.orgtype,
            status: userData?.status,
            datemodified: moment(Date.now()).format("YYYY-MM-DDTHH:mm:ss"),
            utcOffset: userData?.utcOffset,
            addresses: addressesValidate,
            services: userData.services,
            token: userData.token
        };

        const settings = {
            method: 'POST',
            body: JSON.stringify(json),
            headers: {
                'Authorization': 'Bearer ' + getToken(),
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        }

        const response = await fetch(getAPI() + `api/register/Users/update`, settings);
        if (!response.ok) {
            const resp = await response.json();
            setResponseMessage(resp.message);
            return;
        }
        else {
            const resp = await response.json();
            authContext.update(resp);
            setShow(true);
        }
    }
    const handleCancelRow = () => {
        setIsEditorVisible(false);
    }

    //const handleAddressEdit = (e, id) => {
    //    const aIndex = addresses.findIndex(x => x.id === id);
    //    if (aIndex === -1) return;
    //    setAddress({ ...addresses[aIndex] });
    //    setIsEditorVisible(true);
    //}

    const handleAddressEdit = (id) => {
        const aIndex = addresses.findIndex(x => x.id === id);
        if (aIndex === -1) return;
        setAddress({ ...addresses[aIndex] });
        setIsEditorVisible(true);
    }

    const handleEditAddress = (addressId) => {
        setEditingAddressId(addressId);
    }

    return (
        <div>
            <div className="col-12">
                <br />
                <h4 className="d-flex justify-content-center hr-title">Validate your Alert Channel</h4>
                <br />
                <div className="p_summary">
                    1 - To validate your email, please click on "<b>EMAIL code</b>" button to generate the code. The Mail containing the code validator will be sent to your mail address in few seconds.<br />
                To validate the phone number, please click on "<b>SMS code</b>" button to generate the code. The SMS containing the code validator will be sent to your number in few seconds.
                </div>
                <div className="p_summary">
                    2 - When you will receive the EMAIL or SMS, please click on "<b>Edit</b>" button, insert the code in the specific box, save and
                </div>
                <div className="p_summary">
                    3 - Click on "<b>Confirm</b>" button to finalise the validation.
            </div>
                <br />
                <div className="p_summary">
                    The code can be generated every 6 hours
            </div>
                <br />
                <div className="p_summary">If you don't receive it please contact <a href="/About/contactus.aspx" target="_blank" >us</a ></div>
                <br />
                <div className="col-12">
                    <button type="button" className="float-right btn btn-info" onClick={handleSubmit} disabled={!isValidated}>Confirm</button>
                </div>
                <br />
                <br />
                <br />
                {
                    addresses.map((item, index) => {
                        return <AddressRow address={item} onRequestEditAddress={handleAddressEdit} onRequestSentSMS={handleSMSCode} onRequestSentTest={handleTest} />
                    })
                }
                <div className="col-12">
                    <button type="button" className="float-right btn btn-info" style={{ float: "right" }} onClick={handleSubmit} disabled={!isValidated}>Confirm</button>
                </div>
                <br />
                <br />
                <br />
            </div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Validate Your Number</Modal.Title>
                </Modal.Header>
                <><Modal.Body>Your addresses have been checked. Now you can receive Gdacs alerts.</Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" className="float-right" onClick={handleClose}>
                            Confirm
                        </Button>
                    </Modal.Footer></>
            </Modal>
            <SlidingPane from="right" style={{ width: "90%" }} isOpen={isEditorVisible} onRequestClose={() => { setIsEditorVisible(false); setAddress(null); setIsVisible(false); }}>
                <ValidateEditor address={address} onRequestSaveCode={handleSaveCode} onRequestCancel={handleCancelRow} >

                </ValidateEditor>
            </SlidingPane>
        </div>
    );

}

const AddressRow = (props) => {
    const authContext = React.useContext(AuthContext);
    const [address, setAddress] = React.useState(props.address);
    const [buttonDisabled, setButtonDisabled] = React.useState(false);
    const [buttonCaptchaDisabled, setButtonCaptchaDisabled] = React.useState(true);
    const [buttonCheckCodeDisabled, setButtonCheckCodeDisabled] = React.useState(false);
    const { width } = useViewPort();
    const breakpoint = 620;
    const captchaRef = useRef(null);

    React.useEffect(() => {

    }, [address]);

    const onRequestEditAddress = (e, addressId) => {
        props.onRequestEditAddress(addressId);
        setButtonCheckCodeDisabled(true);
    }

    const onRequestSentSMS = (address) => {
        props.onRequestSentSMS(address);
    }

    const onRequestSentTest = (address) => {
        props.onRequestSentTest(address);
    }

    const handleCaptchaChange = (e) => {
        setAddress(a => {
            a.tokencaptcha = e;
            return a;
        });
        if(address.tokencaptcha != null)
            setButtonCaptchaDisabled(false);
        else
            setButtonCaptchaDisabled(true);
    }


    return (

        <div >
            <Card className="primary">
                <Card.Header style={{ backgroundColor: "#0099CC", color: "white" }}>
                    <table style={{ width: "100%" }}>
                        <tr >
                            <td style={{ textAlign: "center", width: "20%", borderBottom: "0px" }}>
                                {props.address.idServiceType === 1 ?
                                    <EnvelopeFill color="white" size={18} />
                                    : props.address.idServiceType === 3 ? <Telephone color="white" size={18} />
                                        : <Phone color="white" size={18} />}
                            </td>
                            <td style={{ borderBottom: "0px" }} >
                                {props.address.addressValue}
                            </td>
                        </tr>
                    </table>
                </Card.Header>
                <Card.Body className="card-body flex-column h-100">
                    <Card.Text>
                        <table style={{ width: "100%" }}>
                            <tr>
                                <td style={{ width: "50%" }}>Check Code : </td>
                                <td style={{ textAlign: "center" }}>{props.address.checkvalidate === true ? props.address.checkcode : "----"}</td>
                            </tr>
                            <br />
                            <tr>
                                <td style={{ width: "50%" }}>Validate : </td>
                                <td style={{ textAlign: "center" }}>{props.address.checkvalidate === true && props.address.checkcode != null ? <BsIcons.BsCheck color="#0099CC" size={18} /> :
                                    props.address.checkvalidate === false && props.address.checkcode !== null ? <FaIcons.FaQuestion size={16} /> : <RiIcons.RiCloseFill color="#FF0000" size={18} />}
                                </td>
                            </tr>
                            <br />
                            <tr>
                                <td className="p_summary input-feedback" style={{ borderBottom: "0px" }}>{props.address.messageText}</td>
                            </tr>
                            <br />
                            <tr>
                                <td style={{ width: "50%" , borderBottom: "0px" }}>
                                    <button type="button" className="btn btn-info" onClick={(event) => onRequestEditAddress(event, props.address.id)} disabled={buttonCheckCodeDisabled || props.address.checkvalidate === true}>Check Code</button>
                                </td>
                                {props.address.checkvalidate === false &&
                                    <td style={{ width: "50%", textAlign: "right", borderBottom: "0px" }}>
                                    {props.address.idServiceType === 1 ?
                                        <button type="button" className="btn btn-info" onClick={() => onRequestSentSMS(props.address)} disabled={buttonCaptchaDisabled || buttonDisabled || (props.address.checkvalidate === true ? true : false)} >EMAIL Code</button>
                                        :
                                        <button type="button" className="btn btn-info" onClick={() => onRequestSentSMS(props.address)} disabled={buttonCaptchaDisabled || buttonDisabled || (props.address.checkvalidate === true ? true : false)} >SMS Code</button>                                      
                                    }
                                    </td>
                                }
                                {props.address.checkvalidate === true &&
                                    <td style={{ textAlign: "right", borderBottom: "0px" }}>
                                    <button type='button ' className="btn btn-info" onClick={() => onRequestSentTest(props.address)} disabled={buttonCaptchaDisabled || (props.address.checkvalidate === false || props.address.checkvalidate === null ? true : false)} >Test</button>
                                    </td>
                                }
                            </tr>
                            <br />
                                <tr>
                                    <td style={{ maxWidth: "260px", borderBottom: "0px" }}>
                                            <>

                                                <form className="captcha">
                                                    <ReCAPTCHA
                                                        sitekey={process.env.REACT_APP_SITE_KEY}
                                                        ref={captchaRef}
                                                        onChange={handleCaptchaChange}
                                                    />
                                                </form>
                                            </>
                                    </td>
                            </tr>
                        </table>
{/*                        {props.address.messageText !== "" &&*/}

{/*                        }*/}
                    </Card.Text>
                </Card.Body>
            </Card>
            <br />
        </div>
    )
}

export { ValidateWidget };